// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-button[data-v-fa4f5c28],.icon-button__wrap[data-v-fa4f5c28]{align-items:center;display:flex}.icon-button__wrap[data-v-fa4f5c28]{height:1.5rem;justify-content:center;margin-right:1rem;width:1.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
